import { ActionReducer, combineReducers, MetaReducer } from '@ngrx/store';
import { CORE_ACTIONS } from '@ispm/core/constants/core-actions.constant';
import {
  bpmnDeploymentIdentifier, bpmnXml,
  bpmnXmlParsingStatus,
  executedActivities,
  executionHistoryParsingStatus,
  executionPath,
  guidedBoxes, initialState,
  latestSelectedNodeId, nodeSelectionDependencies,
  nodesNamesSuffixes,
  patientData,
  processExecutionStatus,
  processInstanceId,
  selectedTreatmentNodeId,
  userSelectionStatus
} from '@ispm-client/modules/process-executor/store';
import {treeNavigationConf} from "@ispm-client/modules/process-executor/store/reducers/tree-navigation-conf.reducer";
import {mandatoryNoteVisited} from "@ispm-client/modules/process-executor/store/reducers/mandatory-note-visited.reducer";

const combinedReducers = {
  bpmnDeploymentIdentifier: bpmnDeploymentIdentifier,
  bpmnXml: bpmnXml,
  processInstanceId: processInstanceId,
  executedActivities: executedActivities,
  executionHistoryParsingStatus: executionHistoryParsingStatus,
  bpmnXmlParsingStatus: bpmnXmlParsingStatus,
  executionPath: executionPath,
  processExecutionStatus: processExecutionStatus,
  selectedTreatmentNodeId: selectedTreatmentNodeId,
  nodesNamesSuffixes: nodesNamesSuffixes,
  guidedBoxes: guidedBoxes,
  patientData: patientData,
  latestSelectedNodeId: latestSelectedNodeId,
  handelingUserSelectionStatus: userSelectionStatus,
  treeNavigationConf: treeNavigationConf,
  mandatoryNotesVisited: mandatoryNoteVisited,
  nodeSelectionDependencies
};

const processExecuterMetaReducer = combineReducers(combinedReducers, initialState);

export function processExecuterMetaReducerA(state, action) {
  return processExecuterMetaReducer(state, action);
}
export function clearStateReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action: any) {
    if (action.type === CORE_ACTIONS.CLEAR_ALL_CACHED_ITEMS) {
      return initialState;
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [clearStateReducer];
